import {
  Avatar,
  Layout,
  Row,
  Col,
  theme,
  Button,
  Dropdown,
  Badge,
  message,
} from "antd";
import { BellOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  addPlayingUserId,
  clearState,
  clearUserId,
  incrementTransactionNoti,
  removePlayingUserId,
  updateUserInfo,
} from "../redux/user";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { SOCKET_API } from "../lib/config";
import noti_sound from "../lib/audio/slot_machine.wav";
const { Header } = Layout;

export default function LayoutHeader() {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = [
    {
      label: (
        <Button
          onClick={() => {
            dispatch(clearState());
            navigate("/");
          }}
          type="text"
          icon={<LogoutOutlined />}
        >
          Log Out
        </Button>
      ),
      key: "logOut",
    },
  ];

  const socket = useRef(null);
  useEffect(() => {
    if (!socket.current) {
      socket.current = io(`${SOCKET_API}`, {
        path: "/socket",
        secure: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
        transports: ["websocket"],
        extraHeaders: {
          Authorization: `Bearer ${user.access_token}`,
          Accept: `application/json`,
          "x-swagger-bypass": user.csrf_token,
          "Access-Control-Allow-Credentials": true,
        },
        query: {
          token: user.access_token,
        },
      });

      socket.current.on("connect", () => {
        console.log("connect socket");
      });

      socket.current.on("transaction", (res) => {
        playSound();
        dispatch(incrementTransactionNoti());
      });

      socket.current.on("play_game", (res) => {
        try {
          dispatch(addPlayingUserId(res));
        } catch (error) {
          console.error("Error in socket play game", error);
        }
      });

      socket.current.on("wallet_update", (res) => {
        try {
          const message = JSON.parse(res);

          dispatch(removePlayingUserId(message.user_id));

          dispatch(
            updateUserInfo({
              user_play_game_id: message.user_id,
              user_points: message.points,
              play_game: message.play_game,
            })
          );
        } catch (error) {
          console.error("Error in socket wallet_update", error);
        }
      });
      return () => {
        if (socket.current) {
          socket.current.disconnect();
          socket.current = null;
        }
      };
    }
  }, []);

  function playSound() {
    const audio = new Audio(noti_sound);
    audio.muted = false;
    audio.play();
  }

  return (
    <Header
      style={{
        background: colorBgContainer,
        display: "flex",
        alignItems: "center",
        boxShadow:
          user.select_theme === "white"
            ? "0 0px 6px 0 #d1a9a9"
            : "0 0px 6px 0 #000000",
      }}
    >
      <Row justify="end" align="middle" style={{ width: "100%", gap: "80px" }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <Badge
            count={user.transaction_noti}
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              backgroundColor: "green",
            }}
          >
            <Button
              onClick={() => navigate("/transaction")}
              type="text"
              icon={<BellOutlined style={{ fontSize: 24 }} />}
            />
          </Badge>
        </Col>
        <Col>
          <Dropdown menu={{ items }}>
            <Button
              type="text"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "20px 10px",
              }}
            >
              <Avatar icon={<UserOutlined />} />
              {user.code}
            </Button>
          </Dropdown>
        </Col>
      </Row>
    </Header>
  );
}
